import { create } from 'zustand';

/**
 * UI state for the Admin Users page.
 *
 * The Invite dialog is opened from two places — the in-page header button
 * on desktop and the AdminTopbar mobile action — so its open state has to
 * live outside the page component. Zustand keeps it light: no provider,
 * no context, no prop drilling through AdminShell → AdminTopbar.
 */
interface AdminUsersUiState {
  inviteDialogOpen: boolean;
  setInviteDialogOpen: (open: boolean) => void;
  openInviteDialog: () => void;
  closeInviteDialog: () => void;
}

export const useAdminUsersUiStore = create<AdminUsersUiState>((set) => ({
  inviteDialogOpen: false,
  setInviteDialogOpen: (open) => set({ inviteDialogOpen: open }),
  openInviteDialog: () => set({ inviteDialogOpen: true }),
  closeInviteDialog: () => set({ inviteDialogOpen: false }),
}));
